import { useEffect } from "react"
import { Navigate, Route, Routes, useParams } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { questionData } from "./state/questions"
import { useAnswerControls } from "./hooks/useAnswerControls"
import { deckMap } from "./questions/decks"
import { Slider } from "./components/Slider"
import { DeckChooser } from "./components/DeckChooser"

const UrlSlider = () => {
	const { deck, round, index } = useParams()
	const setQuestions = useSetRecoilState(questionData)
	const selected = (deck && deckMap[deck]) || deckMap["2022-09-29"]

	useEffect(() => {
		setQuestions(selected.questions)
	}, [setQuestions, selected])

	return <Slider key={selected.slug} round={+round!} index={index === "summary" ? "summary" : +index!} />
}

const LegacyRedirect = () => {
	const { round, index } = useParams()
	return <Navigate to={`/play/2022-09-29/${round}/${index}`} replace />
}

export const App = () => {
	useAnswerControls()
	return (
		<Routes>
			<Route path="/" element={<DeckChooser />} />
			<Route path="/play/:deck/:round/:index" element={<UrlSlider />} />
			<Route path="/:round/:index" element={<LegacyRedirect />} />
			<Route path="*" element={<DeckChooser />} />
		</Routes>
	)
}
